import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// import { API_URL } from '../shared/config';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SaveView } from '../clases/SaveView';
import { ServerResponse } from '../interfaces/ServerResponse';
import { ViewFromServer } from '../interfaces/ViewFromServer';
import { UpdateView } from '../clases/UpdateView';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  API_URL = environment.API_URL;

  constructor(private http: HttpClient, public shared: SharedService) { }

  getViews(): Observable<ServerResponse<ViewFromServer>>{
    let url = `${this.API_URL}/user/functionality/list_users_view`;
    return this.http.get<ServerResponse<ViewFromServer>>(url)
  }

  saveView(json: SaveView): Observable<ServerResponse<ViewFromServer>>{
    let url = `${this.API_URL}/user/functionality/new_users_view`;
    return this.http.post<ServerResponse<ViewFromServer>>(url, json)
  }

  modifyView(json: UpdateView){
    let url = `${this.API_URL}/user/functionality/update_users_view`;
    return this.http.post(url, json)
  }

  deleteView(file_uuid: string){
    let url = `${this.API_URL}/user/functionality/delete_users_view`;
    const params = new HttpParams({ fromObject: {
      file_uuid
    }});
    return this.http.post(url, {file_uuid}, {
      params
    })
  }

}
